import React from 'react'
import { useEffect, useRef, useState, createRef } from 'react'
import { SLowcodeList, SBack } from 'shj-components'
import config from './config'
import { useParams } from 'react-router-dom'
import { refundApplyLogList, httpCompanyList } from '@/services/fmsServices'

export default function PaymentServiceManage() {
  const listRef = useRef<any>()
  const { id } = useParams()
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.refundApplyId = id
        refundApplyLogList(current, pageSize, query).then(res => {
          resolve(res)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      let orgCompanyArr = await httpCompanyList()
      resolve({
        orgCompanyArr: orgCompanyArr,
      })
    })
  }

  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {},
    customRender: {},
  }
  return (
    <SBack title={`退款变更记录`} level={2}>
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
    </SBack>
  )
}
